import { inject, Provider } from '@angular/core';
import { of } from 'rxjs';

import { Cb2PreviewStateService } from '@core/services/cb2-preview/cb2-preview-state.service';

import {
  KIOSK_PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE,
  KioskPaymentMethodPickerBlockDataSource,
} from './kiosk-payment-method-picker-block-view-model';
import { KioskPaymentMethodPickerBlockPreviewDataSource } from './kiosk-payment-method-picker-block-preview-data-source';

export function provideKioskPaymentMethodPickerBlockDataSource(): Provider[] {
  return [
    KioskPaymentMethodPickerBlockPreviewDataSource,
    {
      provide: KIOSK_PAYMENT_METHOD_PICKER_BLOCK_DATA_SOURCE,
      useFactory: (): KioskPaymentMethodPickerBlockDataSource => {
        const previewState = inject(Cb2PreviewStateService);
        return previewState.isActive()
          ? inject(KioskPaymentMethodPickerBlockPreviewDataSource)
          : {
              vm$: of(null),
            };
      },
    },
  ];
}
